'use strict';

import Backbone from 'backbone';
import config from '../../js/config';
import utilities from '../../js/utilities';
import $ from 'jquery';
import $global from '../../js/globalElements';

export default class NotificationBar extends Backbone.View {
  get events() {
    return {
      'click .js-dismissNotification': 'dismiss'
    }
  }

  initialize() {
    this.show();
  }

  show(data) {
    this.render(data);
    this.animateIn();
  }

  render(data = {}) {
    this.$el.html(this.template(data));
  }

  animateIn() {
    setTimeout(() => {
      this.$el.addClass('NotificationBar--animate');
      if ($global.$window.outerWidth() < config.breakpoints.laptop) {
        let top = $('.head').height();
        this.$el.css('top', top + 'px');
      }
    }, 1);
  }

  dismiss(e) {
    e.stopPropagation();
    this.hide();
  }

  hide() {
    this.$el.removeClass('NotificationBar--animate');

    // After css animation has finished
    this.$el.one(utilities.getTransitionEndName(), () => {
      this.$el.find('.NotificationBar-container').addClass(config.classes.isHidden);
    });
  }
}



// WEBPACK FOOTER //
// ./assets/components/NotificationBar/NotificationBar.js